import 'jquery-validation';
import 'jquery-validation/dist/additional-methods';
import 'jquery-validation/dist/localization/messages_it';

import $ from 'jquery';

export const BaseIgnoreList = '.select2-container input,.select2-search input,.no-validate,:disabled';
export function useValidator(...options: (JQueryValidation.ValidationOptions | undefined)[]) {
    const defaults: JQueryValidation.ValidationOptions = {
        //backward compatible with jquery forms
        ignore: `${BaseIgnoreList}[readonly]`,
        ignoreTitle: true,
        errorElement: 'div',
        errorClass: 'validation-label text-danger',
        validClass: 'validation-label text-success',
        errorPlacement(error, element) {
            let parent = element.parent();
            if(parent.is('.bs-date-picker') || parent.is('.fileinput-button') || parent.is('.input-group')) {
                parent = parent.parent();
            }
            error.appendTo(parent);
        },
        highlight(element) {
            const el = $(element);
            const parent = el.parent();
            parent.addClass('has-error').removeClass('has-success');
            if(el.attr('id')) {
                parent.parent().find(`label[for='${el.attr('id')}']`).addClass('text-danger').removeClass('text-success');
            }
        },
        unhighlight(element) {
            const el = $(element);
            const parent = el.parent();
            parent.addClass('has-success').removeClass('has-error');
            if(el.attr('id')) {
                parent.parent().find(`label[for='${el.attr('id')}']`).addClass('text-success').removeClass('text-danger');
            }
        },
    };

    const _options: JQueryValidation.ValidationOptions = Object.assign({}, defaults, ...options);
    return _options;
}
